export default __webpack_public_path__ + "images/f8dacddaf49f9c4aad3d4cc94dd60445-thanksgiving.webp";